const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTcpremium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27pt",
    height: "29pt",
    viewBox: "0 0 27 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,40.784314%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 18.398438 20.167969 C 20.304688 20.167969 21.851562 18.664062 21.851562 16.808594 C 21.851562 14.953125 20.304688 13.449219 18.398438 13.449219 C 16.492188 13.449219 14.945312 14.953125 14.945312 16.808594 C 14.941406 17.699219 15.304688 18.558594 15.953125 19.1875 C 16.601562 19.820312 17.480469 20.171875 18.398438 20.167969 Z M 9.191406 20.167969 C 11.101562 20.167969 12.644531 18.664062 12.644531 16.808594 C 12.644531 14.953125 11.101562 13.449219 9.195312 13.449219 C 7.285156 13.449219 5.742188 14.953125 5.742188 16.808594 C 5.738281 17.703125 6.101562 18.558594 6.75 19.1875 C 7.398438 19.820312 8.277344 20.171875 9.191406 20.167969 Z M 9.191406 22.410156 C 6.511719 22.410156 1.136719 23.71875 1.136719 26.328125 L 1.136719 29.125 L 17.246094 29.125 L 17.246094 26.328125 C 17.246094 23.71875 11.875 22.410156 9.191406 22.410156 Z M 18.398438 22.410156 C 18.066406 22.410156 17.683594 22.429688 17.28125 22.464844 C 18.652344 23.304688 19.5 24.753906 19.546875 26.328125 L 19.546875 29.125 L 26.453125 29.125 L 26.453125 26.328125 C 26.453125 23.71875 21.078125 22.410156 18.398438 22.410156 Z M 18.398438 22.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,40.784314%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 13.417969 6.785156 L 16.238281 8.441406 L 15.496094 5.320312 L 17.984375 3.21875 L 14.703125 2.945312 L 13.417969 0 L 12.136719 2.945312 L 8.855469 3.21875 L 11.347656 5.320312 L 10.605469 8.441406 Z M 13.417969 6.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,40.784314%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 23.488281 10.636719 L 25.558594 11.851562 L 25.011719 9.558594 L 26.839844 8.015625 L 24.429688 7.816406 L 23.488281 5.652344 L 22.546875 7.816406 L 20.136719 8.015625 L 21.964844 9.554688 L 21.417969 11.851562 Z M 23.488281 10.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,40.784314%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 3.351562 10.636719 L 5.425781 11.851562 L 4.875 9.558594 L 6.703125 8.015625 L 4.292969 7.816406 L 3.351562 5.652344 L 2.410156 7.816406 L 0 8.015625 L 1.832031 9.554688 L 1.28125 11.851562 Z M 3.351562 10.636719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTcpremium);
export default __webpack_public_path__ + "static/media/icon_tcpremium.38993db5cb4b0d0c7ffda50b1e94aeca.svg";
export { ForwardRef as ReactComponent };